import Vue from 'vue'

export const announcements = {
    state: {
        announcements: null,
        status: 'idle',
        pagination: null,
        total: null,
        sortOptions: [
            {
                query: 'PUBLICATION_DATE',
                label: 'Data dodania'
            },
            {
                query: 'EXPIRE_DATE',
                label: 'Data wygaśnięcia'
            },
            {
                query: 'TITLE',
                label: 'Nazwa'
            }
        ],
        sort: {
            by: 'PUBLICATION_DATE',
            direction: 'desc'
        },
        filters: {
            read: {
                type: 'ui-checkbox-input',
                value: undefined,
                tooltip: 'Nieprzeczytane',
                text: 'Nowe'
            },
            favourite: {
                type: 'ui-checkbox-input',
                value: undefined,
                text: 'Wyróżnione',
                tooltip: 'Ulubione / zapisane na później'
            },
            id: {
                type: 'search-input',
                value: '',
                searchParamsTooltip: ['ID ogłoszenia', 'tytule', 'treści']
            }
        },
        searchResultCount: {
            current: null,
            archival: null
        }
    },
    mutations: {
        SET_ANNOUNCEMENTS(state, payload) {
            state.announcements = payload
        },
        SET_ANNOUNCEMENTS_TOTAL(state, payload) {
            state.total = payload
        },
        SET_ANNOUNCEMENTS_STATUS(state, payload) {
            state.status = payload
        },
        SET_ANNOUNCEMENTS_PAGINATION(state, payload) {
            state.pagination = payload
        },
        SET_ANNOUNCEMENTS_SORT(state, payload) {
            state.sort = payload
        },
        SET_ANNOUNCEMENTS_SEARCH_RESULT_COUNT(state, payload) {
            state.searchResultCount = payload
        },
        SET_ANNOUNCEMENTS_FILTER(state, payload) {
            Vue.set(state.filters[payload.filter], 'value', payload.value)
        },
        RESET_ANNOUNCEMENTS_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        }
    },
    actions: {
        async fetchAnnouncements({ state, dispatch, getters }, payload) {
            try {
                const userId = getters.userId

                const res = await this.$api.post(
                    `users/${userId}/announcements`,
                    {
                        ...payload,
                        deleted: false
                    }
                )
                return res
            } catch (err) {
                console.log(err)
            }
        },
        async loadAnnouncements({ state, commit, dispatch }, payload) {
            try {
                commit('SET_ANNOUNCEMENTS_STATUS', 'loading')
                delete payload.append

                const searchValue = state.filters.id.value
                const newsId = isNaN(searchValue) ? null : searchValue
                const params = {
                    sorting: payload.sort?.by || state.sort.by,
                    direction: payload.sort?.direction || state.sort.direction,
                    offset: state.pagination?.offset,
                    limit: state.pagination?.limit,
                    keywords: searchValue,
                    ...payload,
                    type: 'ANNOUNCEMENT',
                    newsId,
                    isOr: true
                }
                if (state.filters.read.value) params.read = false
                if (state.filters.favourite.value) params.favourite = true
                if (payload.sort) delete params.sort

                const res = await dispatch('fetchAnnouncements', params)

                if (!res.data?.data) {
                    commit('SET_ANNOUNCEMENTS', [])
                    return
                }

                commit('SET_ANNOUNCEMENTS', res.data.data?.news)
                commit('SET_ANNOUNCEMENTS_PAGINATION', res.data.data.resultSet)

                if (searchValue) {
                    const searchRes = await dispatch('fetchAnnouncements', {
                        ...params,
                        archival: !params.archival
                    })
                    const resCount = res.data.data.resultSet.total
                    const searchResCount = searchRes.data.data.resultSet.total
                    commit('SET_ANNOUNCEMENTS_SEARCH_RESULT_COUNT', {
                        current: params.archival ? searchResCount : resCount,
                        archival: params.archival ? resCount : searchResCount
                    })
                } else {
                    dispatch('resetAnnouncementsSearchResultCount')
                }
            } catch (err) {
                console.log(err)
            } finally {
                commit('SET_ANNOUNCEMENTS_STATUS', 'idle')
            }
        },
        async markAnnouncementAsRead({ commit, getters }, payload) {
            try {
                const announcements = getters.getAnnouncements
                const announcement = announcements.find(
                    announcement => announcement.id === payload.id
                )
                if (announcement.read && !payload.unread) return

                const res = await this.$api.patch(
                    `users/${getters.userId}/announcements/${payload.id}?unread=${payload.unread}`
                )

                if (!res) return
                announcement.read = !payload.unread
                commit('SET_ANNOUNCEMENTS', announcements)
                return res
            } catch (err) {
                console.log(err)
            }
        },

        async fetchAnnouncementsTotal({ commit, getters, dispatch }) {
            try {
                const userId = getters.userId
                const res = await this.$api.post(
                    `users/${userId}/announcements`,
                    {
                        limit: 1,
                        deleted: false,
                        archival: false,
                        read: false,
                        type: 'ANNOUNCEMENT'
                    }
                )
                commit('SET_ANNOUNCEMENTS_TOTAL', res.data.data.resultSet.total)
                return res
            } catch (err) {
                console.log(err)
            }
        },

        setAnnouncementsSort({ commit }, payload) {
            commit('SET_ANNOUNCEMENTS_SORT', payload)
        },
        toggleFavoriteAnnouncement(
            { state, getters, dispatch, commit },
            payload
        ) {
            const userId = getters.userId

            return this.$api
                .patch(
                    `users/${userId}/announcements/${payload.id}/favourite?favourite=${payload.favourite}`
                )
                .then(response => {
                    if (response.status === 200) {
                        dispatch('addNotification', {
                            type: 'success',
                            content: payload.favourite
                                ? 'Dodano do ulubionych'
                                : 'Usunięto z ulubionych'
                        })
                    } else {
                        dispatch('addNotification', {
                            type: 'danger',
                            content: 'Wystąpił błąd'
                        })
                    }
                    return response
                })
        },
        resetAnnouncementsSearchResultCount({ state, commit }) {
            if (
                state.searchResultCount.archival > -1 ||
                state.searchResultCount.current > -1
            ) {
                commit('SET_ANNOUNCEMENTS_SEARCH_RESULT_COUNT', {
                    current: null,
                    archival: null
                })
            }
        },
        async markAllAnnouncementAsRead({ getters, commit }) {
            try {
                const announcements = getters.getAnnouncements
                const res = await this.$api.patch(
                    `users/${getters.userId}/announcementsRead?type=ANNOUNCEMENT`
                )

                if (!res) return

                announcements.forEach(el => {
                    el.read = true
                })
                commit('SET_ANNOUNCEMENTS', announcements)
            } catch (err) {
                console.log(err)
            }
        }
    },
    getters: {
        getAnnouncements: state => state.announcements,
        getAnnouncementsStatus: state => state.status,
        getAnnouncementsPagination: state => state.pagination,
        getAnnouncementsSortOptions: state => state.sortOptions,
        getAnnouncementsSort: state => state.sort,
        getAnnouncementsFilters: state => state.filters,
        getAnnouncementsTotal: state =>
            state.total && state.total > 99 ? '99+' : state.total,
        getAnnouncementsTotalTooltip: state =>
            'Liczba nieprzeczytanych ogłoszeń: ' + state.total,
        getAnnouncementsSearchResultCount: state => state.searchResultCount
    }
}
